import { useEffect, useRef } from 'react';
import { active } from './utils';
export const useRestoreFocus = ({ enabled = true }) => {
    const prevActiveRef = useRef(null);
    useEffect(() => {
        if (!enabled)
            return;
        if (active() !== (document === null || document === void 0 ? void 0 : document.body))
            prevActiveRef.current = active();
        // Focus previously active element on unmount
        return () => { var _a; return (_a = prevActiveRef.current) === null || _a === void 0 ? void 0 : _a.focus(preventScroll); };
    }, [enabled]);
};
const preventScroll = { preventScroll: true };
//# sourceMappingURL=useRestoreFocus.js.map